// extracted by mini-css-extract-plugin
export default {"Dialog":"GoToDialog_Dialog__onaqw","Label":"GoToDialog_Label__ODGaF","Input":"GoToDialog_Input__7zVPM"};